"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProducts = exports.getProduct = exports.getCategory = exports.getCategories = void 0;
var _utils = require("../utils");
var _paramKeys = _interopRequireDefault(require("./paramKeys"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

// We must use a client with no parameters in order to have required/optional match the API spec

// This is defined here, rather than `types.ts`, because it relies on `Client` and `QueryKeys`,
// and making those generic would add too much complexity.

const getProducts = exports.getProducts = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/products'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getProducts'], ...(0, _utils.getCustomKeys)(params)];
    return [...getProducts.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getProduct = exports.getProduct = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/products/', params.id],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getProduct'], ...(0, _utils.getCustomKeys)(params)];
    return [...getProduct.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getCategories = exports.getCategories = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/categories'],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCategories'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCategories.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};
const getCategory = exports.getCategory = {
  path: params => ['/commerce-sdk-react', '/organizations/', params.organizationId, '/categories/', params.id],
  queryKey: params => {
    const paramKeys = [..._paramKeys.default['getCategory'], ...(0, _utils.getCustomKeys)(params)];
    return [...getCategory.path(params), (0, _utils.pick)(params, paramKeys)];
  }
};